<template lang="pug">
  .product-container
    .product-header
      .product-title
        p {{ $t('iMedia Matrix') }}
        p {{ $t('媒介数据审计工具') }}
      .product-desc
        p {{ $t('iMedia Matrix是一个集海量媒体点位、价格于一体的数据库产品，涉及各行业各品牌的广告投放数据。') }}
        p {{ $t('涵盖数字媒体、电视广告、室内户外、报纸杂志、电台广播5个媒介大类的787家媒体、26,000条点位及价格数据。') }}
      el-button.product-link(
        @click="onApplyAccount"
      ) {{ $t('申请Demo账号') }}
      .product-img
        img(
          src="@/assets/i_media_matrix-1.png"
        )
    .product-content-container
      .product-content-item
        .product-content-desc.product-content-desc__ml
          .desc-title {{ $t('数据全面') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('多方数据源') }}
          .desc {{ $t('iMedia Matrix的数据来自三个方面，第一是复歌根据服务的历史合作客户提供的相关供应商资源执行信息提炼而出，第二是所有入驻复歌小程序贵了么的供应商提供的相关资源点位及价格，第三则是复歌与第三方审计咨询公司合作，获取了相关数据对整个数据库进行有效补充。') }}

          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('参考价值高') }}
          .desc {{ $t('基于丰富且强大的媒介点位及价格数据库，iMedia Matrix已为多家广告主进行营销审计工作时提供参考及BenchMark，同时也与一些审计咨询公司深入合作，不断完善补充数据，强化数据价值。') }}
        img(
          src="@/assets/i_media_matrix-2.png"
        )
      .product-content-item
        .product-content-desc.product-content-desc__mr
          .desc-title {{ $t('维度丰富') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('行业/品牌/代理商应有尽有') }}
          .desc {{ $t('每一条数据除了常规的点位、价格信息之外同时拥有投放方信息，如行业、品牌、所属代理商、对应供应商、执行年份月份等深度信息。') }}

          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('刊例/执行/返点一应俱全') }}
          .desc {{ $t('iMedia Matrix中无论是刊例价数据、执行价数据还是媒体返点数据，均有对应的数据库记录了详细信息，支持用户分别查询单个数据库，所见即所得。') }}
        img(
          src="@/assets/i_media_matrix-3.png"
          )
    section#clients-say
      div.clients-say__content
        img(
          alt="what our clients say"
          src="@/assets/clients-say-logo.png"
        )
        div
          ul.clients-say__case__content
            li.active
              p {{ $t('使用iMedia Matrix的媒介数据库，帮助我们处理企业营销审计的工作效率大大提升。凭借其提供丰富的媒介点位数据、媒介价格数据、媒介返点信息等海量数据，不仅省去了各审计人员的大量信息查询工作、行业BenchMark调查，还通过这些数据获取相关的洞察，为审计人员出具总结报告时提供了相关依据。') }}
          ul.clients-say__case__avators.f.f-sa
            li.active_li
              div
                img(
                  alt="avator"
                  src="@/assets/default-avator.png"
                )
              p
                | 某审计公司部门经理
    contact
</template>

<script>
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    Contact: MobileContact
  },
  methods: {
    onApplyAccount () {
      this.$router.push('/contact?redirectUrl=/product/i_media_matrix&buttonName=申请Demo账号')
    }
  }
}
</script>
